import api from './api';

interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

interface ChangePasswordResponse {
  message: string;
}

interface ForgotPasswordRequest {
  username: string;
}

interface ForgotPasswordResponse {
  message: string;
}

interface ResetPasswordRequest {
  token: string;
  newPassword: string;
}

interface ResetPasswordResponse {
  message: string;
}

const authService = {
  changePassword: async (currentPassword: string, newPassword: string): Promise<ChangePasswordResponse> => {
    const response = await api.post<ChangePasswordResponse>('/api/auth/changepassword', {
      currentPassword,
      newPassword
    });
    return response.data;
  },

  forgotPassword: async (username: string): Promise<ForgotPasswordResponse> => {
    const response = await api.post<ForgotPasswordResponse>('/api/auth/forgotpassword', {
      username
    });
    return response.data;
  },

  resetPassword: async (token: string, newPassword: string): Promise<ResetPasswordResponse> => {
    const response = await api.post<ResetPasswordResponse>('/api/auth/resetpassword', {
      token,
      newPassword
    });
    return response.data;
  }
};

export default authService;

